import React from "react";
import "./TempleFeatures.css";

const features = [
  {
    title: "Features of Maha Kshetram",
    subtitle: "The Great Temple",
    text: "Other than the accepted spiritual and structural aspects, the following ten characteristics elevate the position of a temple to a Mahakshetram (Great Temple). They are antiquity, presence of records, historical importance, origin in a forest, nearness to an ocean, location at an elevation, royal connections, mention in ancient literatures, magnificence of architecture and grandeur of festivals. The Sree Padmanabhaswamy Temple qualifies all these characteristics.",
    icon: "✦",
    featured: true,
  },
  {
    title: "Ananthasayanam Idol",
    text: "It is believed that twelve Salagramas stones, when worshipped together gain the potency of a Mahakshetram (Great Temple). The interior of the Katusarkara Idol of Sree Padmanabha Swamy is made up of twelve thousand and eight (12008) Salagramas collected from the bed of the river Gandaki in Nepal. Salagramas represent Sree Maha Vishnu. This Temple gains the greatness and sanctity of a thousand great temples.",
    icon: "◈",
  },
  {
    title: "Ottakkal Mandapam",
    text: "The Ottakkal Mandapam (single stone platform) in the Sree Padmanabhaswamy Temple is a striking feature. The Mandapam is in front of the sanctum sanctorum of Lord Sree Padmanabhaswamy. This structure is built with a single slab of granite which is two and a half feet thick and twenty feet square. The Abhishekams to Sree Padmanabhaswamy are performed in this Mandapam. Its granite pillars are covered with gold.",
    icon: "◆",
  },
  {
    title: "The Presence of Shiva",
    text: "The presence of Shiva within the Sreekovil adds significance to the sanctity of a Maha Kshetram dedicated to Vishnu. Many areas of the Temple are adorned with the images of Lord Shiva. As in many other Temples in Malayala Nadu, this Temple too stood free of cult clashes that often marred the face of orthodox religion in part of India. Siva’s presence is proof enough.",
    icon: "ॐ",
  },
  {
    title: "Abhisravana Mandapam",
    text: "This structure is in front of the Ottakkal Mandapam but outside the Cherruchuttu containing the sanctum sanctorum. Special poojas related with Temple festivals are performed here. Devotees use this Mandapam for meditation and prayer.",
    icon: "✧",
  },
  {
    title: "Kulasekhara Mandapam",
    text: "It is a marvelous and fantastic architectural work on stone. It is also known as Aayiramkaal Mandapam and Sapthaswara Mandapam. It is supported by 28 balustrades of pillars. The pillars on the four corners can produce musical notes when tapped. The pillars are adorned with exquisitely carved figures in half and full relief.",
    icon: "♬",
  },
  {
    title: "The Golden Flag-staff",
    subtitle: "Dwaja Stambham",
    text: "An eighty feet high pole near the eastern corridor was installed by Anizham Tirunal. A teak wood of this dimension was carried from the nearby forest to the Temple. As per Sastras the wood should not touch the ground while in transport. The teak pole was then covered completely with gold foils. The apex of the flag pole has a figure of Garuda Swamy, in kneeling posture.",
    icon: "⚑",
  },
  {
    title: "Nine Entrances",
    text: "The Temple has nine entrances, indicating the nine orifices of the human body.",
    icon: "⑨",
  },
  {
    title: "Gopuram",
    text: "The Temple has a seven storeyed gopuram built on the eastern entrance. It is a fine example of South Indian architecture and is exclusively in Dravidian style. It is about 35 meters height. On the top there are 7 golden domes suggesting pointers to the seven Worlds. The 10 incarnations of Lord Vishnu are portrayed inside the first storey of the gopuram. The other three entrances are double storied Padippuras in typical Kerala Style. Entry to the upper levels of the Gopuram is restricted.",
    icon: "⌂",
  },
  {
    title: "The Sreebalippura",
    subtitle: "The Sacred Corridor",
    text: "The Temple has a marvelous Sreebalippura. This magnificent rectangular corridor built of stone surrounds the main shrines and it is through this corridor that the Vahanams are taken out during Sreebali (procession). Records say that daily 4000 stone artisans, 6000 laborers and 100 elephants worked for a period of 6 months to finish the construction of the Sreebalippura. Sreebalippura is supported by 365 and a one quarter of pillars. Each pillar is a monolith. The master artisan Ananthapadmanabha Moothassari was in charge of the work.",
    icon: "▥",
  },
  {
    title: "Theerthams",
    subtitle: "Sacred Water Resources",
    text: "The Temple has a large number of sacred water resources situated even in places far away from the Temple. Of these, the main one Padmatheertham is located on the eastern side of the Temple. Padmatheertham is one of the oldest water bodies in the city of Thiruvananthapuram.",
    icon: "≋",
  },
  {
    title: "Bells",
    text: "Large numbers of bells adorn the Temple. In most cases the tip of the bell has a metal banian leaf attached to its tongue.",
    icon: "♢",
  },
  {
    title: "Multiplicity of Mandapams",
    text: "Another feature of this Temple is the multiplicity of Mandapams (platforms). There are 11 mandapams in the Temple and 8 in the Padmatheertham pond.",
    icon: "▦",
  },
  {
    title: "Mural Paintings",
    text: "The outer walls of the sanctum sanctorum of Lord Padmanabha and Sree Krishna are adorned with murals. Of these, the Ananthasayanam on the backside of the sanctum is termed as the largest one among the temple murals of Kerala, and was painted by a Brahmin artist by name Chalayil Kalahasti. It is 18 feet long.",
    icon: "▣",
  },
  {
    title: "Thiruvambadi Sree Krishnaswamy Temple",
    subtitle: "A Temple within the Temple",
    text: "Even though the Thiruvambadi Sree Krishna Swamy Temple is inside the main Temple walls, it enjoys the status of a separate Temple with separate flag-staff, sacred stones and its own rites and rituals. It is quite unusual.",
    icon: "❖",
  },
];

export default function TempleFeatures() {
  return (
    <section className="temple-features">

      {/* HEADER */}
      {/* <div className="features-header">

        <span className="eyebrow">
          SREE PADMANABHASWAMY TEMPLE
        </span>

        <h1>
          The Grandeur of
          <span> Maha Kshetram</span>
        </h1>

        <div className="header-decoration">
          <span></span>
          <b>✦</b>
          <span></span>
        </div>

        <p>
          Discover the remarkable architectural, spiritual and historical
          features that distinguish Sree Padmanabhaswamy Temple as a
          Maha Kshetram — a Great Temple.
        </p>

      </div> */}


      {/* INFOGRAPHIC */}
      <div className="features-timeline">

        {features.map((feature, index) => (

          <article
            className={`feature-item ${
              index % 2 === 0 ? "left" : "right"
            } ${feature.featured ? "featured" : ""}`}
            key={index}
          >

            {/* NUMBER */}
            <div className="feature-number">
              {(index + 1).toString().padStart(2, "0")}
            </div>


            {/* CONNECTOR */}
            <div className="feature-node">
              <span>{feature.icon}</span>
            </div>


            {/* CARD */}
            <div className="feature-card">

              <div className="feature-top">

                <span className="feature-index">
                  FEATURE {(index + 1).toString().padStart(2, "0")}
                </span>

                <span className="feature-symbol">
                  {feature.icon}
                </span>

              </div>

              <h2>{feature.title}</h2>

              {feature.subtitle && (
                <h3>{feature.subtitle}</h3>
              )}

              <div className="feature-line"></div>

              <p>{feature.text}</p>

            </div>

          </article>

        ))}

      </div>

    </section>
  );
}